module.exports = __webpack_public_path__ + "static/media/polytope_52_5_52_diff_shapes_layers_2_5.e564189c.gif";